import React, { useState, useEffect } from 'react';
import {
  PaperProps,
  statusOptions,
  statusSuccess,
  requiredField,
} from 'constants';
import {
  onSave,
  emptyFunction,
  refinePayload,
  useNotification,
  fieldValidation,
  getDialogHeading,
  renderSaveCancelButtons,
} from 'utils/commonUtils';
import * as yup from 'yup';
import MDBox from 'components/MDBox';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { GridForm } from 'components/Ui/styled';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormInputText } from 'components/Common/Forms/FormTextField';
import FormInputDropdown from 'components/Common/Forms/FormInputDropDown';
import { putTutoringV2SessionStatus } from '../BookNewSessionTabV2/services/bookNewSessionTabV2Api';

const schema = yup.object().shape({
  status: yup
    .string()
    .oneOf(['completed', 'rescheduled', 'no_show'], requiredField)
    .required(requiredField),
  statusNote: fieldValidation(4000),
});

const BookedSessionStatusV2Dialog = (props) => {
  const { rowData, open, setOpen, fetchBookedSessions } = props;

  const dispatch = useDispatch();

  const { setOpenNotification, setNotificationMessage, NotificationPopup } =
    useNotification();

  const [loadingButton, setLoadingButton] = useState(false);

  const { sessionId, status, statusNote } = rowData || {};

  const defaultValue = {
    statusNote: statusNote || '',
    status: status && status !== 'booked' ? status.toLowerCase() : '',
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(schema),
  });

  const { handleSubmit, control, reset, formState } = useFunction;
  const { errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue.status, defaultValue.statusNote]);

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
  };

  const onSubmit = async (data) => {
    const { status, statusNote } = data;
    const payload = {
      status,
      note: statusNote,
    };

    onSave(
      statusSuccess,
      false,
      emptyFunction,
      putTutoringV2SessionStatus,
      refinePayload(payload),
      sessionId,
      fetchBookedSessions,
      handleClose,
      setOpenNotification,
      setNotificationMessage,
      dispatch,
      setLoadingButton,
      loadingButton,
    );
  };

  return (
    <>
      <Dialog open={open} PaperProps={PaperProps}>
        {getDialogHeading('Status', handleClose)}
        <GridForm container spacing={2}>
          <Grid item xs={12}>
            <FormInputDropdown
              name="status"
              label="Status"
              control={control}
              options={statusOptions}
              errors={!!errors.status}
              helperText={errors?.status?.message}
            />
            <FormInputText
              rows={2}
              multiline
              type="text"
              label="Note"
              name="statusNote"
              control={control}
              errors={!!errors.statusNote}
              helperText={errors?.statusNote?.message}
            />
            <MDBox mt={1}></MDBox>
            {renderSaveCancelButtons(
              handleClose,
              handleSubmit(onSubmit),
              loadingButton,
              false,
              '',
              'Update Status',
            )}
          </Grid>
        </GridForm>
      </Dialog>
      <NotificationPopup />
    </>
  );
};

export default BookedSessionStatusV2Dialog;
